import { STATES_LIST } from "../pages/fdp/FdpConstants";

export const ADDRESS_REGEX = /^(?!.*\s$)(?!^\s)[A-Za-z0-9\s.,-]+$/;
export const CITY_REGEX = /^(?=.*[^\s])[A-Za-z0-9 _-]+$/;
export const STATE_REGEX = new RegExp(`\\b(${STATES_LIST.join("|")})\\b`);
export const ZIPCODE_REGEX = /^\d{5}(?:-\d{4})?$/;
export const AIRPORT_CODE_REGEX = /^[A-Za-z0-9]{3}$/;
export const CLIENT_STORE_ID_REGEX = /^[A-Za-z0-9]+$/;

export const AIRPORT_CODE_REGEX_INVALID_MSG =
  "Entered Nearest Airport Code is invalid, Please follow format e.g: 16A, DFW, BOS";
export const CLIENT_STORE_ID_REGEX_INVALID_MSG =
  "Entered Client Store Id is invalid, Please follow format e.g: 389ABC56";
export const ADDRESS_REGEX_INVALID_MSG =
  "Entered Address is invalid, Please follow format e.g: 1235 Interquest Pkwy";
export const CITY_REGEX_INVALID_MSG =
  "Entered City is invalid, Please follow format e.g: Colorado Springs";
export const ZIPCODE_REGEX_INVALID_MSG =
  "Extered Zipcode is invalid, Please follow format e.g: 80921 or 80921-1234";
